const faqs = [
  {
    q: '白云视频是否需要注册登录？',
    a: '不需要。白云视频为完全免费的在线观影平台，无需注册、无需登录、无需付费，打开网站即可直接观看所有高清影视内容。',
  },
  {
    q: '白云视频的资源更新速度如何？',
    a: '我们保持每日更新，平均每天上线128部新资源。院线新片、热播剧集、综艺节目均与主流平台保持同步，让你第一时间看到最新内容。',
  },
  {
    q: '播放视频时卡顿或缓冲怎么办？',
    a: '白云视频采用多线路智能分发技术，如遇卡顿可尝试切换播放线路。推荐使用Chrome、Edge等主流浏览器，并确保网络环境稳定。全站99.9%内容支持流畅播放。',
  },
  {
    q: '支持哪些设备观看？画质如何？',
    a: '全面支持手机、平板和电脑浏览器访问，无需下载任何APP。资源涵盖1080P至4K多种清晰度，系统会自动根据你的网络状况选择最佳画质。',
  },
  {
    q: '白云视频与97视频、丝瓜视频是什么关系？',
    a: '白云视频是独立的影视聚合平台，与97视频、丝瓜视频、蓝莓视频、91在线视频等同属高清影视资源类站点，我们聚合收录同类优质资源，为用户提供更多选择。',
  },
  {
    q: '遇到无法播放的内容如何反馈？',
    a: '如果你发现任何影片无法正常播放，欢迎通过本站的"联系我们"板块提交反馈。我们会在24小时内检查并修复资源链接，确保观影体验。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-6 rounded-full bg-accent-500"></div>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
            常见问题
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-xl border border-background-200/60 p-5 md:p-6"
            >
              <h3 className="font-heading text-sm md:text-base font-bold text-foreground-900 flex items-start gap-3">
                <span className="text-primary-500 text-lg font-extrabold shrink-0">Q</span>
                <span>{faq.q}</span>
              </h3>
              <p className="text-foreground-600 text-sm mt-3 pl-7 leading-relaxed">
                {faq.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}